'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { TypeIcon } from 'src/components';
import { useLogging } from 'src/context/logging';
import Link from 'next/link';
import { getProfileUrl } from 'src/utils/profileUrl';

interface CompactLocationRowItemProps {
  location: Record<string, any>;
}

const CompactLocationRowItem: React.FC<CompactLocationRowItemProps> = ({
  location,
}) => {
  const log = useLogging();
  const percentage =
    location?.percentage || location?.percentage === 0
      ? `${location?.percentage}%`
      : 'Unavailable';

  const name = location?.name || 'Other';
  const hasProviderId = location?.provider_id;

  return (
    <div
      className="flex justify-between items-center border-b border-neutral-100 px-4 py-2"
      role="listitem"
    >
      {hasProviderId ? (
        <>
          <Link
            id={`volume-by-location-provider-${location?.provider_id}`}
            href={getProfileUrl(location?.type, location?.provider_id)}
            scroll={false}
            className="flex items-center w-full gap-2 text-sky-900 no-underline"
            onClick={(e) => {
              e.stopPropagation();
              log.event('Location Clicked', {
                source: 'web',
                location: 'VolumeByLocation',
                provider_id: location?.provider_id,
              });
            }}
          >
            <TypeIcon
              type={location.soc_type || location.type}
              className="text-link"
            />
            <span className="text-sm font-medium !text-link">
              {name}
              <Icon icon={faExternalLinkAlt} className="pl-1" size="xs" />
            </span>
          </Link>
          <span className="text-sm text-neutral-800">{percentage}</span>
        </>
      ) : (
        <>
          <div className="flex items-center gap-2 w-full">
            <span className="text-sm font-medium">{name}</span>
          </div>
          <span className="text-sm">{percentage}</span>
        </>
      )}
    </div>
  );
};

export default CompactLocationRowItem;
